export const GIZMO_EXCEPTION = {
  baseContainer: {
    movement: {
      rotation: ["y"]
    },
    name: "baseContainer",
    appliesToChildren: true
  },
  characterContainer: {
    movement: {
      rotation: ["y"]
    },
    name: "characterContainer",
    appliesToChildren: false
  }
};
